import PropTypes from 'prop-types'
import { APPLY_FDR_URL } from 'src/common/constants'
import { useCallback, useMemo } from 'react'
import { useAnalytics } from '../../../common/analytics'
import { useLeadId } from '../../../common/lead-id'
import { useRouter } from 'next/router'
import { buildQueryString } from '../../../common/utils'
import { useNavigateToApply } from 'src/common/hooks/useNavigateToApply'
import AnimatedArrowRedCTA from './AnimatedArrowRedCTA'
import classNames from 'classnames'

const CallToAction = ({
  className,
  title,
  text,
  additional_info = {},
  nav_link_section,
  fullWidth = false,
  ...props
}) => {
  const { track } = useAnalytics()
  const leadId = useLeadId()
  const { query: baseQuery } = useRouter()
  const { navigateToApply } = useNavigateToApply()

  const query = useMemo(
    () => buildQueryString(baseQuery, leadId),
    [baseQuery, leadId]
  )

  const url = `${APPLY_FDR_URL()}?${query}`

  const handleButtonClick = useCallback(
    (e) => {
      e.preventDefault()

      const data = {
        nav_link_section: nav_link_section,
        page_section: title,
        click_type: 'Button Click',
        click_id: text,
        click_url: url,
        click_text: `FDR-Web | ${text}`,
        track_event: 'button_click',
        additional_info,
      }
      track(data, { event_type: 'conversion' }, 'button_click')
      setTimeout(() => navigateToApply(), 800)
    },
    [
      nav_link_section,
      title,
      text,
      url,
      additional_info,
      track,
      navigateToApply,
    ]
  )

  return (
    <AnimatedArrowRedCTA
      {...props}
      buttonText={text}
      onClick={handleButtonClick}
      url={url}
      className={classNames(fullWidth ? 'w-full' : 'w-72', 'm-auto', className)}
    />
  )
}

CallToAction.defaultProps = {
  className: '',
  fontClassName: 'text-sm font-normal leading-snug tracking-normal text-white',
  children: [],
  bgColor: 'bg-red-700',
  text: 'Get Your Free Debt Evaluation',
  pageLocation: '',
  title: '',
  endIcon: null,
  additional_info: undefined,
  nav_link_section: 'Page',
}

CallToAction.propTypes = {
  className: PropTypes.string,
  bgColor: PropTypes.string,
  fontClassName: PropTypes.string,
  text: PropTypes.string,
  pageLocation: PropTypes.string,
  title: PropTypes.string,
  endIcon: PropTypes.node,
  experimentData: PropTypes.object,
  additional_info: PropTypes.object,
}

export default CallToAction
